<template>
    <div class="swiper-box">
      <!--第一banner位-->
      <!-- <div  id="myBanner"  data-spm="101596"  data-spm-type="all" ></div> -->
      <div class="banner"  data-spm="101596" data-spm-type="all" v-show="Cyjf_banner.length > 0">
        <swiper :options="bannerOption" ref="swiper" data-spm-type="all">
          <swiper-slide v-for="(item,index) in Cyjf_banner" :key="index" >
            <img @click="bannerLink(item)" :src="item.advertiseViewImg" alt="" class="bannerImg">
          </swiper-slide>
        </swiper>
      </div>
      <!--第二banner位（取前5个）-->
      <div class="mySwiper" v-if="Cyjf_dhjf.length > 1" id="getPoint">
        <div class="mySwiper-header">
          <img src="./image/mySwiper-header1.png" alt="">
          <p>积分汇聚</p>

        </div>
        <swiper :options="swiperOption" ref="mySwiper" data-spm-type="all" data-spm="103632" class="myswiper">
          <swiper-slide v-for="(item,index) in Cyjf_dhjf" :key="index" :data-gio="item.gioData" data-gio-event="PageClick">
            <img @click="toBindLink(item)" :src="item.advertiseViewImg" alt="">
            <p @click="toBindLink(item)" >{{item.advertiseIntroduce}}</p>
          </swiper-slide>
        </swiper>
      </div>
      <!-- <div class="mySwiper" v-if="Cyjf_dhjf.length > 1">
        <div class="mySwiper-header">
          <img src="./image/mySwiper-header.png" alt="">
          <p>积分互通</p>
        </div>
        <div class="swiperBox">
          <div class="swiperFather"  draggable="true" @dragstart="drag($event)" >
            <div v-for="(item,index) in Cyjf_dhjf" :key="index" class="swiperItem">
                <img :src="item.advertiseViewImg" alt="" class="bannerImg">
                <p>{{item.advertiseIntroduce}}</p>
            </div>
          </div>
        </div> -->
        <!-- <swiper :options="bannerOption" ref="swiper" data-spm-type="all">
          <swiper-slide v-for="(item,index) in Cyjf_banner" :key="index" >
            <img @click="bannerLink(item)" :src="item.advertiseViewImg" alt="" class="bannerImg">
          </swiper-slide>
        </swiper> -->
      <!-- </div> -->
      <!--四宫格(最多显示四个)-->
      <div class="cardList" data-spm-type="all" data-spm="101598" v-show="Cyjf_game.length > 0">
        <div class="cardList-header">
          <img src="./image/cardList-header.png" alt="">
          <p>玩游戏赚积分</p>
        </div>
        <div class="cardBox">
          <div class="card" v-for="(item,index) in Cyjf_game" :key="index">
            <a :href="item.jumpLink">
              <img :src="item.advertiseViewImg" alt="">
            </a>
          </div>
        </div>
      </div>
      <!--<div class="banner" v-if="imgList != ''">-->
            <!--<div class="box" v-for="(item,index) in imgList"><img @click="imgLink(item.adUrl)" :src="imgUrl+'/'+item.adContent" alt=""></div>-->
        <!--</div>-->
    </div>
</template>
<script>
import 'swiper/css/swiper.css'
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import { adKeyId } from "@/assets/config/keyId";
import { server } from "@/assets/config/env";
import userUtil from 'cy_static/userUtil'
import serverUtil from "cy_static/serverUtil";
import adModule from 'cy_static/adModule';
import sliderUtil from 'cy_static/sliderUtil';
import { reqCyQueryAdvert, reqCyButlerAllBindInfo, reqCyButlerBindingCMCC, reqCyButlerActiveCMCC,
        reqCyButlerBindingCeair, reqCyButlerBindingBoc, reqCyLoginValidation } from 'changyo-public-api'
import cookie from 'js-cookie'
import getCurrentUrl from '@/assets/libs/getCurrentUrl'
import util from '@/assets/libs/util'
import requestApi from 'changyo-public-api/src/libs/requestApi'
import ajaxUtil from 'cy_static/ajaxUtil'

export default {
	name: 'Article',
	props: {
    isApiDataLoaded: {
      type: Function,
      default: () => {}
    }
  },
	data() {
		const self = this
		return {
        bannerIndex:0,
        imgUrl: server.imgUrl,
        keyId:adKeyId.H5_qybzq,
        token:userUtil.get() || '',
        Cyjf_banner:[],
        Cyjf_dhjf:[],
        Cyjf_game:[],
        bannerIndex:0,
        lastTranslate:0,
        bannerOption:{
          slidesPerView: 1,
          centeredSlides: true,
          initialSlide: 1,
          autoplay: {
            delay: 2000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          loop:true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
        },
        swiperOption:{
          slidesPerView: 3.5,
          spaceBetween:22,
          freeMode: true,
          // navigation: {
          //   nextEl: '.next',
          //   prevEl: '.prev'
          // }
          // slidesPerView: 'auto',
          // centeredSlides: true,
          // initialSlide: 1,
            // freeMode: true,
            // freeModeSticky: true,
          // freeMode: {
            // freeModeMomentum: false,
            // freeModeSticky: true

          // },
          // autoplay: {
          //   delay: 100000000,
          //   stopOnLastSlide: false,
          //   disableOnInteraction: false
          // },
          // autoplay: false,
          // loop:false,
          // observer:true,//修改swiper自己或子元素时，自动初始化swiper
          // observeParents:true,//修改swiper的父元素时，自动初始化swiper
        },
        keyIds: {
          Cyjf_banner:'H5_jfpd_banner', // banner
          Cyjf_dhjf:'H5_slt_jfpd_dhjf', // 兑换积分
          Cyjf_game:'H5_jfpd_yx', // 游戏
        },
        loadedApiCount: 0,
        param: {
          appId: 'Changyoyo_Life_Central',
          featuredFirstCode: '',  // keyid
          channel: 'Changyoyo_Life_Central',
          pageNum: 1,
          pageSize: 10
        },
        mobileBindUrl: '', // 绑定链接
        airBindUrl: '', // 绑定链接
        bocBindUrl: '', // 绑定链接
        mobileFreezeUrl: '',  //冻结链接
        mobileBindStatus: 1,  // 绑定状态
        airBindStatus: 1,  // 绑定状态
        bocBindStatus: 1,  // 绑定状态
        positionX:0,
        positionY:0,
		}
	},
	components:{
		Swiper,
		SwiperSlide
	},
	computed: {
		swiper() {
      return this.$refs.mySwiper.swiper
      return this.$refs.swiper.swiper
		}
	},
	watch: {
		bannerIndex(value,oldValue){
		}
  },
	created() {
    this.imgUrl = server.imgUrl,
    this._getBanner2()
    this._getBanner()
	},
	mounted() {
    this._getExtensionArea()
    this.getAllBindInfo()
  },
	methods: {
    async getAllBindInfo() {
      const param = { login_token: cookie.get('login_token') }
      const info = await Promise.all([
        reqCyButlerAllBindInfo(param).catch(err => console.log(err))
      ])
      cookie.set('jumpBack', getCurrentUrl() + '#/hjf')
      cookie.set('flag', 1)
      if(!info[0]){
        this.bocBindStatus = 0
        this.airBindStatus = 0
        this.mobileBindStatus = 0
        return;
      }
      // null 为一次都未绑定过  0 未绑定
      if(info[0].data.boc) {
        if(info[0].data.boc.bindStatus === 0 || info[0].data.boc.bindStatus === 3){
          this.bocBindStatus = 0
        }
      }
      if(info[0].data.ceair) {
        if(info[0].data.ceair.bindStatus === 0 || info[0].data.ceair.bindStatus === 3){
          this.airBindStatus = 0
        }
      }
      if (info[0].data.cmcc){
        if(info[0].data.cmcc.bindStatus === 0 || info[0].data.cmcc.bindStatus === 3){
          this.mobileBindStatus = 0
        }
        if(info[0].data.cmcc.bindStatus === 2){
          this.mobileBindStatus = 2
          this.toActiveLink('mobile')
        }
      }
    },
    bannerLink(item) {
      location.href = item.jumpLink
    },
    // 获取cmcc boc  ceair  绑定页面地址
    async toBindLink(item) {
      var param = {
        login_token: cookie.get('login_token'),
        callback: 'https://' + document.domain + '/butler/exchange/cmcc/CMCC.htm',
        failUrl: getCurrentUrl() + '#/hjf'
      }
      cookie.set('jumpBack', getCurrentUrl() + '#/hjf')
      cookie.set('flag', 1)

      if (item.remark === 'cmcc') {
        if (this.mobileBindStatus === 1 || this.mobileBindStatus === 2) {
          this.imgLink(item)
        } else {
          const res = await reqCyButlerBindingCMCC(param).catch(err => console.log(err))
          if (res && res.data) {
            if (res.data.mobileurl) {
              this.mobileBindUrl = res.data.mobileurl
              this.imgLink(item)
            } else {
              util.toast(res.data.msg)
            }
          }
        }
      } else if (item.remark === 'ceair') {
        if (this.airBindStatus === 1) {
          this.imgLink(item)
        } else {
          param.callback = 'https://' + document.domain + '/butler/exchange/ceair/CEAIR.htm'
          const res = await reqCyButlerBindingCeair(param).catch(err => console.log(err))

          if (res && res.data) {
            if (res.data.bindingurl) {
              this.airBindUrl= res.data.bindingurl
              this.imgLink(item)
            } else {
              util.toast(res.data.msg)
            }
          }
        }
      } else if (item.remark === 'boc') {
        if (this.bocBindStatus === 1) {
          this.imgLink(item)
        } else {
          param.callback = 'https://' + document.domain + '/butler/exchange/BOC.htm'
          const res = await reqCyButlerBindingBoc(param).catch(err => console.log(err))

          if (res && res.data) {
            if (res.data.bindingurl) {
              this.bocBindUrl = res.data.bindingurl
              this.imgLink(item)
            } else {
              util.toast(res.data.msg)
            }
          }
        }
      } else {
        this.imgLink(item)
      }
    },
    // 冻结
    async toActiveLink(type) {
      const param = {
        login_token: cookie.get('login_token'),
        callback:  'https://' + document.domain + '/butler/exchange/cmcc/CMCC.htm',
        failUrl: getCurrentUrl() + '#/hjf'
      }
      if (type === 'mobile') {
        cookie.set('jumpBack', getCurrentUrl() + '#/hjf')
        cookie.set('flag', 1)
        const res = await reqCyButlerActiveCMCC(param).catch(err => console.log(err))
        if (res) {
          this.mobileFreezeUrl = res.data.mobileurl
        }
      }
    },
    _checkApiStatus() {
      this.loadedApiCount += 1

      if (this.loadedApiCount === 3) {
        this.isApiDataLoaded()
      }
    },
    async _getBanner(){// 轮播图推荐
      this.param.featuredFirstCode = this.keyIds.Cyjf_banner

      const res = await reqCyQueryAdvert(this.param).catch(err => console.log(err))

      if (res && res.data && res.data.advertiseOnlines && res.data.advertiseOnlines.length > 0) {
        this.Cyjf_banner = res.data.advertiseOnlines
        this._checkApiStatus()
      }
    },
    async _getBanner2(){// 积分兑换推荐
      this.param.featuredFirstCode = this.keyIds.Cyjf_dhjf

      const res = await reqCyQueryAdvert(this.param).catch(err => console.log(err))

      if (res && res.data && res.data.advertiseOnlines && res.data.advertiseOnlines.length > 0) {
        function compare(property){
          return function(a,b){
            const value1 = a[property];
            const value2 = b[property];
            return value1 - value2;
          }
        }
        this.Cyjf_dhjf = res.data.advertiseOnlines.sort(compare('sort'))
        for (var i = 0 ; i<this.Cyjf_dhjf.length; i++) {
          if(this.Cyjf_dhjf[i].remark === 'cmcc') {
            this.Cyjf_dhjf[i]['gioData'] = JSON.stringify({
              pitCode: '103632',
              pitPositionName: '积分管家-积分兑换-中国移动',
              ModuleCode: 'C7_2',
              ModuleName: '积分管家首页-中部_1'
            })
          }
          if(this.Cyjf_dhjf[i].remark === 'boc') {
            this.Cyjf_dhjf[i]['gioData'] = JSON.stringify({
              pitCode: '103632',
              pitPositionName: '积分管家-积分兑换-中国银行',
              ModuleCode: 'C7_3',
              ModuleName: '积分管家首页-中部_1'
            })
          }
          if(this.Cyjf_dhjf[i].remark === 'ceair') {
            this.Cyjf_dhjf[i]['gioData'] = JSON.stringify({
              pitCode: '103632',
              pitPositionName: '积分管家-积分兑换-东方航空',
              ModuleCode: 'C7_5',
              ModuleName: '积分管家首页-中部_1'
            })
          }
          if(this.Cyjf_dhjf[i].remark === 'jfjyz') {
            this.Cyjf_dhjf[i]['gioData'] = JSON.stringify({
              pitCode: '103632',
              pitPositionName: '积分管家-积分兑换-积分加油站',
              ModuleCode: 'C7_1',
              ModuleName: '积分管家首页-中部_1'
            })
          }
          if(this.Cyjf_dhjf[i].remark === 'gjdw') {
            this.Cyjf_dhjf[i]['gioData'] = JSON.stringify({
              pitCode: '103632',
              pitPositionName: '积分管家-积分兑换-国家电网',
              ModuleCode: 'C7_6',
              ModuleName: '积分管家首页-中部_1'
            })
          }
          if(this.Cyjf_dhjf[i].remark === 'hrt') {
            this.Cyjf_dhjf[i]['gioData'] = JSON.stringify({
              pitCode: '103632',
              pitPositionName: '积分管家-积分兑换-华润通',
              ModuleCode: 'C7_7',
              ModuleName: '积分管家首页-中部_1'
            })
          }
          if(this.Cyjf_dhjf[i].remark === 'jd') {
            this.Cyjf_dhjf[i]['gioData'] = JSON.stringify({
              pitCode: '103632',
              pitPositionName: '积分管家-积分兑换-京豆',
              ModuleCode: 'C7_4',
              ModuleName: '积分管家首页-中部_1'
            })
          }
        }
        this._checkApiStatus()
      }
    },
    toPointStrategy() {
      this.$router.push('/hjfStrategy')
    },
    async _getExtensionArea(){ // 游戏推荐

      this.param.featuredFirstCode = this.keyIds.Cyjf_game

      const res = await reqCyQueryAdvert(this.param).catch(err => console.log(err))

      if (res && res.data && res.data.advertiseOnlines && res.data.advertiseOnlines.length > 0) {
        this.Cyjf_game = res.data.advertiseOnlines
        this._checkApiStatus()
      }

    },
    imgLink(item){
      if (item.remark === 'cmcc') {  // 0未绑定状态   1绑定状态  2冻结(中国移动)
        if (this.mobileBindStatus === 0) {
          // cookie.set('jumpBack', 'https://test-m-stg3.ppppoints.com/butler/exchange/cmcc/CMCC.htm')
          // cookie.Del('jumpBack')
          location.href = this.mobileBindUrl
        } else if (this.mobileBindStatus === 1) {
          location.href = item.jumpLink
        } else if (this.mobileBindStatus === 2) {
          location.href = this.mobileFreezeUrl
        }
      } else if (item.remark === 'boc') {
        if (this.bocBindStatus === 0) {
          location.href = this.bocBindUrl
        } else if (this.bocBindStatus === 1) {
          location.href = item.jumpLink
        }
      } else if (item.remark === 'ceair') {
        if (this.airBindStatus === 0) {
          location.href = this.airBindUrl
        } else if (this.airBindStatus === 1) {
          location.href = item.jumpLink
        }
      } else if (item.remark === 'gjdw') {
        this.getGJDWUrl()
      } else {
        location.href = item.jumpLink
      }
    },
    // 获取国电跳转绑定页地址
    getGJDWUrl() {
      ajaxUtil.loadData('/butler/sgcc/sgccBangdingUrl', {
        method: 'POST',
        body: {
          login_token: cookie.get('login_token'),
        }
      }).then(res => {
        location.href = res.data
      })
    }
	}
}

</script>
<style>
  #myBanner{position:relative;height: 2.4rem;border-radius:6px;margin-top:.2rem;}
  #myBanner .content{display:table;white-space:nowrap}
  #myBanner .l-item .l-img img{width: 7.08rem; height: 2.4rem;}
  #myBanner .l-item{display:inline-block;width:7.5rem;position:relative}
  #myBanner .navMenu{position:absolute;left:0;right:0;bottom:10px;padding:0px 0;display:inline-block;text-align:center}
  #myBanner .navMenu b{width:6px;height:6px;display:inline-block;background:rgba(255,255,255,.5);margin:0 0px;border-radius:50%}
  #myBanner .navMenu b.curr{background:#fff}
</style>
<style type="style" lang="scss" scoped>
    .banner {
      margin-top: .2rem;
      .bannerImg {
        width: 7.08rem !important;
        height: 2.4rem !important;
      }
    }
    .mySwiper {
      margin-top: .42rem;

      .swiperBox{
        display: flex;
        overflow: hidden;
        .swiperFather {
          display: flex;
          position: relative;     /*定位*/
        top: 10px;
        left: 10px;
        }
        .swiperItem {
          width: 2rem;
          height: 1.92rem;
          img {
            width: 100% !important;
            height: 100% !important;
          }
        }
      }
      .mySwiper-header {
        display: flex;
        img {
          width: .38rem;
          height: .33rem;
          margin-left: 10px;
        }
        p {
          font-size: .25rem;
          font-weight:bold;
          text-align: left;
          color: #000000;
          line-height: -0.75rem;
          margin-left: .16rem;
        }
        .strategy{
          position:absolute;
          color:#DDD0C3;
          margin-top:45px;
          margin-right:20px;
          text-align:right;
          width:90%;
          height: .4rem;
          top:0
        }
      }
    }
    .myswiper{
      margin-left: 10px;
    }
    .swiper-box .swiper-container{
      padding: 0.2rem 0 0.4rem;
      height:100%;
    }
    .swiper-box swiper-container img{
      width:100%;
      /*height:100%;*/
    }
    .swiper-box .swiper-slide {
      width: 2rem;
      height: 1.92rem;
      text-align: center;
      font-size: 18px;
      border-radius: 10px;
      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      transition: 300ms;
      margin-right: .13rem;
      // transform: scale(0.9);
    }
    .swiper-box .swiper-slide img{
        width:100%;
        height:100%;
        border-radius: 10px;
        position: relative;
        box-shadow: 0 2px 3px 0 rgba(176,176,176,0.50);
      }
    .swiper-box .swiper-slide p{
      position: absolute;
      bottom: 0.25rem;
      font-size: 0.18rem;
      // font-weight: bold;
      color: #FFF;
      text-align: center;
      width: 90%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .swiper-box .swiper-slide-active,.swiper-slide-duplicate-active{
       transform: scale(1);
     }
    // .swiper-box .swiper-slide-active p,.swiper-slide-duplicate-active p{
    //   transform: scale(0.9);
    // }
    .cardList {
      overflow: hidden;
      .cardList-header {
        display: flex;
        padding-bottom: .28rem;
        img {
          width: .4rem;
          height: .4rem;
        }
        p {
          font-size: .32rem;
          font-weight: 500;
          text-align: left;
          color: #000000;
          line-height: .4rem;
          margin-left: .16rem;
        }
      }
      .cardBox {
        display: flex;
        // justify-content: space-between;
      }
      .cardBox div:nth-child(3) {
        margin-right: 0;
      }
      .card {
        position: relative;
        overflow: hidden;
        float: left;
        width: 2.25rem;
        height: 3.2rem;
        margin-right: .2rem;
        // &:nth-child(odd){
        //   padding: 0 2.5% 2.5% 0;
        // }
        // &:nth-child(even){
        //   padding: 0 0 2.5% 0;
        // }
        a {
          height: 3.2rem;
          display: block;
          border-radius: 4px;
          overflow: hidden;
          img{
            width:100%;
            height: 100%;
          }
        }
      }
    }
</style>
